import { BundleStatus } from 'generated/graphql';

import { OfferData } from './types';

export const toSelectableOffers = (offers: OfferData[]) =>
  offers.filter((offer) => offer.status !== BundleStatus.Archived);

export const toOfferOptions = (offers: OfferData[]) =>
  toSelectableOffers(offers).map((offer) => ({
    value: offer.id,
    label:
      offer.status === BundleStatus.Draft
        ? `${offer.name} (Draft)`
        : offer.name,
  }));
